exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".acl-public[data-v-29d60678],small[data-v-29d60678]{color:gray}.acl-intern[data-v-29d60678]{color:#dacd00}.acl-privat[data-v-29d60678]{color:#be0000}.btn[data-v-29d60678]{padding:4px 10px}.cc-btn-menue[data-v-29d60678]{padding-left:10px;padding-right:0}.media-right[data-v-29d60678]{min-width:100px}.media-left[data-v-29d60678]{padding-left:15px}.cc-kombox-typ[data-v-29d60678]{padding-bottom:30px}.cc-kombox-body[data-v-29d60678]{color:gray;border-left:0 solid red;padding-left:8px;line-height:1.1em;min-width:120px}.media-left .glyphicon[data-v-29d60678]{padding-right:0;font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-29d60678&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/KomboxUserCallerColleague.vue
// module id = 193
// module chunks = 0